import http from "@/apis/http.js";
import { getCookie, setCookie } from "@/apis/cookie";
import bus from "@/apis/bus";
export default {
  state: {
    menus: null,
    getPublic: null,
    menusFilter: null,
    actionMenus: null,
    user: null,
    coinList: null,
    userIsReady: false,
    isLogin: false,
    HeaderAtName: "",
    HeaderChildName: "",
    active: "",
    open: "",
    language: "",
    captcha: {},
    public: null,
    brokerList: [],
    bookList: [],
    underlyingPlatMarket: [],
    editContractData: null,
    languageConfList: [], //开启状态多语言
    // tableH:'594px',//表格默认高度
    tableH: '594px',//表格默认高度
  },
  actions: {
    getPublic({ commit }) {
      http({
        url: "common/public_info",
      }).then((data) => {
        if (data.code.toString() === "0") {
          const res = JSON.parse(JSON.stringify(data.data));
          const { lan } = res;
          // 获取浏览器默认的语言
          let defaultLanguage = "";
          if (navigator.language === "zh-CN" || navigator.language === "zh") {
            defaultLanguage = "zh_CN";
          } else {
            defaultLanguage = "en_US";
          }
          let CookieHaveLan = false;
          const CookieLan = getCookie("lan");
          let language = "";

          if (CookieLan) {
            // lan.forEach((item) => {
            //   if (item.langType === CookieLan) {
            //     CookieHaveLan = true;
            //   }
            // });
            language = CookieLan;
          } else {
            language = defaultLanguage;
          }
          // if (CookieHaveLan) {
          //   language = CookieLan;
          // } else {
          //   language = defaultLanguage;
          // }
          setCookie("lan", language); //备注信息：多语言暂时隐藏
          // setCookie('lan', 'zh_CN')
          commit("setPublic", data.data);

          commit("setLanguage", language);
          commit("setCaptcha", data.data.captcha);
        }
      });
    },
    getMenus({ commit }) {
      http({
        url: this.state.url.common.menus,
      }).then((data) => {
        if (data.code.toString() === "0") {
          const { navList, menuList } = data.data;
          let list = {};
          Object.keys(menuList).forEach((item) => {
            menuList[item].forEach((citem) => {
              if (citem.child.length) {
                citem.child.forEach((sitem) => {
                  list[sitem.atName] = {
                    first: citem.atName,
                    header: item,
                  };
                });
              } else {
                list[citem.atName] = {
                  header: item,
                };
              }
            });
          });
          commit("setMenusFilter", list);
          let str = localStorage.active || "logoMenus";
          let HeaderAtName = "";
          let HeaderChildName = "";
          let open = "";
          Object.keys(menuList).forEach((item) => {
            menuList[item].forEach((citem) => {
              if (citem.child.length) {
                citem.child.forEach((sitem) => {
                  if (sitem.atName === str) {
                    open = citem.atName;
                    HeaderAtName = item;
                  }
                });
              } else {
                if (citem.atName === str) {
                  HeaderAtName = item;
                }
              }
            });
          });
          const obj = {};
          navList.forEach((item) => {
            if (item.child.length) {
              item.child.forEach((citem) => {
                obj[citem.atName] = item.atName;
              });
            } else {
              obj[item.atName] = item.atName;
            }
          });
          if (HeaderAtName.length) {
            if (obj[HeaderAtName] !== HeaderAtName) {
              HeaderChildName = HeaderAtName;
              HeaderAtName = obj[HeaderAtName];
            }
          } else {
            HeaderAtName = "indexManager";
          }
          let name = HeaderAtName;
          if (HeaderChildName.length) {
            name = HeaderChildName;
          }
          commit("setHeaderAtName", HeaderAtName);
          commit("setHeaderChildName", HeaderChildName);
          commit("setActive", str);
          commit("setOpen", open);
          commit("setMenus", data.data);
        }
      });
    },
    getUser({ commit }) {
      http({
        url: "user_info",
      }).then((data) => {
        commit("setUserIsReady", data.data);
        if (data.code.toString() === "0") {


          localStorage.setItem('roleType', data.data.roleType)
          commit("setUser", data.data);
          if (data.data.roleType == 1) {
            setCookie("admin-broker-id", 1);
          } else {
            setCookie("admin-broker-id", data.data.companyId);
          }
          commit("setIsLogin", true);

        } else {
          setTimeout(() => {
            bus.$emit("alert", { type: "error", message: data.msg });
          }, 200);

        }
      });
    },
    getOpenLanguageList({ commit }) {
      http({
        url: "language/langStatuList",
        params: {
          type: 6, //6:管理后台
        },
      }).then((data) => {
        if (data.code.toString() === "0") {
          let arr = [];
          data.data.langStatuList.forEach((item) => {
            if (item.status == 1) {
              arr.push(item);
            }
          });
          commit("setOpenLanguageList", arr.reverse());
        }
      });
    },
    setOpen({ commit }, data) {
      commit("setOpen", data);
    },
    setActive({ commit }, data) {
      commit("setActive", data);
    },
    setHeaderAtName({ commit }, data) {
      commit("setHeaderAtName", data);
    },
    setHeaderChildName({ commit }, data) {
      commit("setHeaderChildName", data);
    },
    setIsLogin({ commit }, data) {
      commit("setIsLogin", data);
    },
    getBrokers({ commit }) {
      http({
        url: "company_list",
      }).then((data) => {
        if (data.code.toString() === "0") {
          if (data.data && data.data.length) {
            commit("setBrokers", data.data);
          }
        }
      });
    },
    getBooks({ commit }) {
      http({
        url: "risk_book_list",
      }).then((data) => {
        if (data.code.toString() === "0") {
          if (data.data && data.data.length) {
            /*let arr = []
            data.data.map((item) => {
              arr.push({label: item.name, value: item.id})
            })
            this.bookList = arr*/
            commit("setBooks", data.data);
          }
        }
      });
    },
    getUnderlyingPlatMarket({ commit }) {
      http({
        url: "get_underlying_plat_market",
      }).then((data) => {
        if (data.code.toString() === "0") {
          if (data.data && data.data.length) {
            commit("setUnderlyingPlatMarket", data.data);
          }
        }
      });
    },
    setEditContractData({ commit }, data) {
      commit("setEditContractData", data);
    },
  },
  mutations: {
    setEditContractData(state, data) {
      state.editContractData = data;
    },
    setCaptcha(state, data) {
      state.captcha = data;
    },
    setLanguage(state, data) {
      state.language = data;
    },
    setHeaderAtName(state, data) {
      state.HeaderAtName = data;
    },
    setHeaderChildName(state, data) {
      state.HeaderChildName = data;
    },
    setActive(state, data) {
      state.active = data;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setMenus(state, data) {
      state.menus = data;
      state.actionMenus = data.actionList;
    },
    setMenusFilter(state, data) {
      state.menusFilter = data;
    },
    setPublic(state, data) {
      state.public = data;
    },
    setUser(state, data) {
      state.user = data;
      sessionStorage.setItem("userID", data.id);
    },
    setUserIsReady(state) {
      state.userIsReady = true;
    },
    setIsLogin(state, data) {
      state.isLogin = data;
    },
    setBrokers(state, data) {
      state.brokerList = data;
    },
    setBooks(state, data) {
      state.bookList = data;
    },
    setUnderlyingPlatMarket(state, data) {
      state.underlyingPlatMarket = data;
    },
    setOpenLanguageList(state, data) {
      state.languageConfList = data;
    },
  },
};
